import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeatureSection from './components/FeatureSection';
import IndustriesSection from './components/IndustriesSection';
import ClientsSection from './components/ClientsSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import BlueSectionDivider from './components/BlueSectionDivider';
import SetApartSection from './components/SetApartSection';
import AwardSection from './components/AwardSection';
import CountriesSection from './components/CountriesSection';
import MagazinesSection from './components/MagazinesSection';
import CustomerReviews from './components/CustomerReviews';
import ResultsSection from './components/ResultsSection';
import TechStackSection from './components/TechStackSection';
import ContactSection from './components/ContactSection';
import AllServices from './pages/AllServices';
import DigitalTransformation from './pages/DigitalTransformation';
import ProductDesign from './pages/ProductDesign';
import MinimumViable from './pages/MinimumViable';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import WebDevelopment from './pages/WebDevelopment';
import MobileDevelopment from './pages/MobileDevelopment';
import NearshoreTeams from './pages/NearshoreTeams';
import AI_DS from './pages/AI_DS';
import UI_UX from './pages/UI_UX';
import AllIndustries from './pages/AllIndustries';


 

import './index.css';
import ScopingSession from './pages/ScopingSession';
import QualityAssurance from './pages/QualityAssurance';
import DigitalAcceleration from './pages/DigitalAcceleration';
import CodeAudit from './pages/CodeAudit';
import UxAudit from './pages/UxAudit';
import Fintech from './pages/Fintech';
import Greentech from './pages/Greentech';
import Healthtech from './pages/Healthtech';
import Legaltech from './pages/Legaltech';
import Manufacturing from './pages/Manufacturing';
import Proptech from './pages/Proptech';
import Retail from './pages/Retail';
import AboutUs from './pages/AboutUs';
import WhyUs from './pages/WhyUs';
import Careers from './pages/Careers';
import Contact  from './pages/Contact';
import Footer from './components/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import CompanyPolicy from './pages/CompanyPolicy';
import PrivacyPolicy from './pages/PrivacyPolicy';


function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        {/* Home Page Route */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <FeatureSection />
              <IndustriesSection />
              <ClientsSection />
              <CaseStudiesSection />
              <BlueSectionDivider />
              <SetApartSection />
             
              
              <BlueSectionDivider />
              <CountriesSection />
              <BlueSectionDivider />
              <MagazinesSection />
              <CustomerReviews />
              <ResultsSection />
              <BlueSectionDivider />
              <TechStackSection />
              <BlueSectionDivider />
              <ContactSection backgroundImage="/contact-bg.webp" />
              
              <Footer/>
            </>
          }
        />

        {/* All Services Page Route */}
        <Route path="/services" element={<AllServices />} />
        <Route path="/services/digital-transformation" element={<DigitalTransformation/>}/>
        <Route path="/services/scoping-session" element={<ScopingSession/>}/>
        <Route path="services/product-design" element={<ProductDesign/>}/>
        <Route path="/services/minimum-viable" element={<MinimumViable/>}/>
        <Route path="/services/software-development" element={<SoftwareDevelopment />} />
        <Route path="/services/web-development" element={<WebDevelopment/>}/>
        <Route path="/services/mobile-development" element={<MobileDevelopment/>}/>
        <Route path="/services/nearshore-teams" element={<NearshoreTeams/>}/>
        <Route path="/services/ai-ds" element={<AI_DS/>}/>
        <Route path="/services/ui-ux" element={<UI_UX/>}/>
        <Route path="/services/qa" element={<QualityAssurance/>}/>
        <Route path="/services/digital-acceleration" element={<DigitalAcceleration/>}/>
        <Route path="/services/code-audit" element={<CodeAudit/>}/>
        <Route path="/services/ux-audit" element={<UxAudit/>}/>
        <Route path="/industries" element={<AllIndustries/>}/>
        <Route path="/portfolio/fintech" element={<Fintech/>}/>
        <Route path="/portfolio/greentech" element={<Greentech/>}/>
        <Route path="/portfolio/healthtech" element={<Healthtech/>}/>
        <Route path="/portfolio/legaltech" element={<Legaltech/>}/>
        <Route path="/portfolio/manufacturing" element={<Manufacturing/>}/>
        <Route path="/portfolio/proptech" element={<Proptech/>}/>
        <Route path="/portfolio/retail" element={<Retail/>}/>
        <Route path="/company/about-us" element={<AboutUs/>}/>
        <Route path="/company/why-us" element={<WhyUs/>}/>
        <Route path="/careers" element={<Careers/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/company-policy" element={<CompanyPolicy/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
      </Routes>
      <ScrollToTopButton />
    </Router>
  );
}

export default App;
